import React, { useCallback, useEffect } from 'react';
import { useSnapshot } from 'valtio';

import { appStore, lightStore, eventsStore, spoutStore } from '../managers/globalState';
import { LIGHT_STATUS } from '../config/constants';

import '../../www/assets/css/light_toggle.css';
// import CameraLightButtonOnSVG from '../../www/assets/images/camera_light_button_on.svg';
// import CameraLightButtonOffSVG from '../../www/assets/images/camera_light_button_off.svg';
import BrightnessIcon from '../../www/assets/images/brightness.svg';

// Light ON: a full circle (same 20x20 frame and viewBox as brightness.svg, so
// the two icons line up exactly). Light OFF uses brightness.svg: a half circle.
const FullCircleIcon = () => (
	<svg viewBox='-2 -2 24 24' preserveAspectRatio='xMinYMin' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10' cy='10' r='10' />
	</svg>
);

const LightToggle = () => {
	const { queries: { lighting: lightingFromURL } } = appStore.stateSnapshot;
	const { spout, spoutGlobe } = useSnapshot(spoutStore.state);
	const { fill } = useSnapshot(lightStore.state);
	const { currentEvent } = useSnapshot(eventsStore.state);

	const isButtonVisible = !currentEvent && (spout !== true || spoutGlobe !== true);

	// Handle lighting URL value
	useEffect(() => {
		// Light on by default for events, otherwise use URL param or LIGHT_STATUS
		const forceLightOn = currentEvent !== null;
		const lightState = forceLightOn || (lightingFromURL ? lightingFromURL === 'flood' : LIGHT_STATUS);

		lightStore.setGlobalState({ fill: lightState });
	}, [lightingFromURL, currentEvent]);

	// Toggle light fill.
	const onClick = useCallback(() => {
		lightStore.setGlobalState({ fill: !fill });
	}, [fill]);

	// "on" = full white circle, "off" = gray half circle (see light_toggle.css).
	const classes = `light-toggle no-select ${fill ? 'on' : 'off secondary'}`;
	let text;
	const is_arabic = window.config && window.config.acceptLanguage && window.config.acceptLanguage == 'ar';
	if(is_arabic){
		text = fill ? 'على' : 'بعيدا';
	} else {
		text = fill ? 'ON' : 'OFF';
	}

	return (isButtonVisible && (
		<button type='button' aria-label='light-toggle' className={classes} value='light' onClick={onClick} title={text}>
			{/* {fill ? <CameraLightButtonOffSVG /> : <CameraLightButtonOnSVG />} */}
			{fill ? <FullCircleIcon /> : <BrightnessIcon />}
		</button>
	)

	);
};

export default LightToggle;
